import type { FC } from "react";
import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";

import type { Props as SelectDefaultProps } from "@des/react-select";
import Select from "@des/react-select";

import type { SelectOptionType } from "./selectOptions";

import styles from "./CustomSelect.module.scss";

export type DEPRECATED_CustomSelectProps = {
  name: string;
  placeholder: string;
  options: SelectOptionType[];
  defaultValue?: SelectOptionType;
  dataTestId?: string;
  inputId?: string;
  isSearchable?: boolean;
  validation?: RegisterOptions;
} & SelectDefaultProps;

type ConditionalWrapperProps = {
  children: React.ReactElement;
  condition: boolean;
  wrapper: (children: React.ReactElement) => React.ReactElement;
};

/**
 * @deprecated use Select from @jti/ui instead
 */

const ConditionalWrapper: FC<ConditionalWrapperProps> = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

/**
 * @deprecated use Select from @jti/ui instead
 */

export const DEPRECATED_CustomSelect: FC<DEPRECATED_CustomSelectProps> = (params) => {
  const { control } = useFormContext();

  return (
    <ConditionalWrapper
      condition={!!params.dataTestId}
      wrapper={(children) => <div data-testid={params.dataTestId}>{children}</div>}
    >
      <Controller
        render={({ field }) => (
          <Select
            {...field}
            inputId={params.inputId}
            className={styles.container}
            classNamePrefix="react-select"
            {...params}
            aria-label={params.placeholder || params.name}
            theme={(theme: any) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary: "black",
              },
              outline: "none",
              boxShadow: "none",
            })}
          />
        )}
        rules={params.validation}
        name={params.name}
        control={control}
        defaultValue={params.defaultValue}
      />
    </ConditionalWrapper>
  );
};
